// src/utils/auth.js

const TOKEN_KEY = 'access_token'
const REFRESH_TOKEN_KEY = 'refresh_token'

/**
 * 设置令牌
 * @param {string} token 访问令牌
 * @param {string} refreshToken 刷新令牌
 */
export function setToken(token, refreshToken) {
  localStorage.setItem(TOKEN_KEY, token)
  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
  }
}

/**
 * 获取访问令牌
 * @returns {string|null}
 */
export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

/**
 * 获取刷新令牌
 * @returns {string|null}
 */
export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN_KEY)
}

/**
 * 移除令牌
 */
export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(REFRESH_TOKEN_KEY)
}

/**
 * 检查是否已认证
 * @returns {boolean}
 */
export function isAuthenticated() {
  return !!getToken()
}


// WEBPACK FOOTER //
// ./src/utils/auth.js